import React from "react";
import { TextField } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";

const useStyles = makeStyles({
  wh: { background: "#ACD1AF" },
  detail: { background: "#EEEE9B" },
  res: { background: "#2977fc75" },
});

const ColoredTextFieldForReqList = props => {
  const classes = useStyles();

  if (props.record[props.source] === null) {
    return null;
  }

  const isWhColored = props => {
    if (props.record.whCount > 0 && props.source === "whCount") return true;
    return false;
  };

  const isDetailColored = props => {
    if (props.record.altPnCount > 0 && props.source === "altPnCount") return true;
    else if (props.record.woCount > 0 && props.source === "woCount") return true;
    else if (props.record.roCount > 0 && props.source === "roCount") return true;
    else if (props.record.poExCount > 0 && props.source === "poExCount") return true;
    return false;
  };

  const isResColored = props => {
    if (props.record.resCount > 0 && props.source === "resCount") return true;
    return false;
  };

  return (
    <TextField
      className={classnames({
        [classes.wh]: isWhColored(props),
        [classes.detail]: isDetailColored(props),
        [classes.res]: isResColored(props),
      })}
      style={{
        display: "grid",
        alignContent: "center",
        alignItems: "center",
        justifyItems: "center",
        justifyContent: "center",
        padding: "5px 15px",
        width: "15px",
      }}
      {...props}
      source={props.displaySource || props.source}
    />
  );
};

export default ColoredTextFieldForReqList;
